import React from 'react';
import WorkspaceGuideDialog from '../../../shared/ui/common/WorkspaceGuideDialog';
import { buildExportGuideContent } from './guide';

interface ExportGuideDialogProps {
  open: boolean;
  onClose: () => void;
  onStartTour: () => void;
  systemCount: number;
  selectedCount: number;
  outputPath: string;
  loading: boolean;
}

const ExportGuideDialog: React.FC<ExportGuideDialogProps> = ({
  open,
  onClose,
  onStartTour,
  systemCount,
  selectedCount,
  outputPath,
  loading,
}) => (
  <WorkspaceGuideDialog
    open={open}
    onClose={onClose}
    dialogTitle="Export guide window"
    onAction={onStartTour}
    {...buildExportGuideContent({
      systemCount,
      selectedCount,
      outputPath,
      loading,
    })}
  />
);

export default ExportGuideDialog;
